module.exports = __webpack_public_path__ + "static/media/16.6a106835.jpg";